import React, { useContext, useEffect, useState } from "react";
import "./index.scss";
import { useFormik, FormikProvider } from "formik";
import { FormRow } from "../../../../components/Form/FormRow";
import { FormItem } from "../../../../components/Form/FormItem";
import { useMediaQuery } from "@material-ui/core";
import { SelectOneRadioOld } from "../../../../components/inputs/RadioGroupOld";
import { CheckboxOld } from "../../../../components/inputs/CheckboxOld";
import { AdditionalPerson } from "../../AdditinalPerson";
import Cart from "../../Cart";
import {
    ITravelQuotationContext,
    TravelQuotationContext,
} from "../../../../contexts/TravelQuotationContext";
import {getAgreeAboutProductLabel, ProductType} from "../../../QuotationForm/other/agreementCheckbox";
import { TravelQuotationCardContext } from "../../../../contexts/TravelQuotationCardContext";
import { ParametrizedFieldOld } from "../../../../components/ParametrizedFieldOld";
import moment from "moment";
import { strings } from "../../../../strings/strings";
import { ProcessingContext } from "../../../../contexts/ProcessingContext";
import { IResponseField } from "../../../../model/reactField";
import { StepControls } from "../../../../components/Scenario/Step/StepControls";
import * as log from "../../../../utils/log";
import { getSnippetByName } from "../../../../api/snippetApiClient";
import { ChatWidget } from "../../../../model/chatWidget";
import { WIDGET_DURATION, WidgetTooltip } from "../../../../App";
import { AutoSubmitting } from "../../../../components/AutoSubmitting";
import { ErrorFieldsContext } from "../../../../contexts/ErrorFieldsContext";
import { LogFunctionalModule } from "../../../../utils/log";
import { useHotjar } from "../../../../utils/hooks/useHotjar";
import { EventTypeKey, useTabCloseTracking } from "../../../QuotationForm/forms/hooks/useTabCloseTracking";

interface Props {
    onFormSubmit: (data: any) => void;
    backStepHandler: (quotation: any) => void;
}

const resident = [
    { value: true, label: strings.residentTrue },
    { value: false, label: strings.residentFalse },
];

export const UserDetailsForm: React.FC<Props> = ({
    onFormSubmit,
    backStepHandler,
}) => {
    const {
        quotation,
        setQuotation,
        payerIsPersonCheckbox,
        setIsPayerIsPersonCheckbox,
        agree1Checkbox,
        setAgree1Checkbox,
        agreeInformCheckbox,
        setAgreeInformCheckbox,
        foundPrimaryInsured,
        setFoundPrimaryInsured,
    } = useContext<ITravelQuotationContext>(TravelQuotationContext);
    const { setProcessingOpen } = useContext(ProcessingContext);
    const isMobile = useMediaQuery("(max-width: 1023px)");
    const {
        startLoadingFromServer,
        validateFields,
        nextIsAvailable,
        updateField,
        currentlyUpdatedFields,
        clearFirstPersonFields
    } = useContext(TravelQuotationCardContext);
    const [residentCountryHidden, setResidentCountryHidden] = useState<boolean>(quotation.travelWebContract.primaryInsured.resident);
    const [residentCountryUpdate, setResidentCountryUpdate] = useState<IResponseField>(null);
    const [documentNumber, setDocumentNumber] = useState<string>("");
    const { additionalErrorFields } = useContext(ErrorFieldsContext);
    const { trackHotjar } = useHotjar()
    const [tempSaveValues, setTempSaveValues] = useState<Record<string, any>>(
        {}
    );

    const getPrimaryInsured = () => {
        if (foundPrimaryInsured && !quotation.travelWebContract.primaryInsured.email) {
            return foundPrimaryInsured;
        }
        return quotation.travelWebContract.primaryInsured;
    }

    /*
        Я переніс використання форми в useFormik через те, що потрібно мати доступ до формПропс, а використання через компонент не
        дає змоги викликати методи з формПропс поза межами контексту форміка
    */
    const formProps = useFormik({
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: {
            agree1: agree1Checkbox,
            agreeInform: agreeInformCheckbox,
            payerIsPerson: payerIsPersonCheckbox,
            quotation: {
                ...quotation,
                travelWebContract: {
                    ...quotation.travelWebContract,
                    primaryInsured: getPrimaryInsured(),
                    persons: foundPrimaryInsured
                        ?   [
                                {
                                    ...quotation.travelWebContract.persons[0],
                                    birthDate: foundPrimaryInsured.birthDate,
                                    givenName: foundPrimaryInsured.givenName,
                                    mobileNumber:
                                        foundPrimaryInsured.mobileNumber,
                                    surname: foundPrimaryInsured.surname,
                                    address:
                                        foundPrimaryInsured?.livingAddress
                                            ?.unstructured,
                                    documentNumber:
                                        foundPrimaryInsured?.registrationDocument
                                            ?.number,
                                },
                                ...quotation.travelWebContract.persons.slice(1)
                            ]
                        : quotation.travelWebContract.persons,
                },
            },
        },
        validate: (values) => {
            setProcessingOpen(true);
            const errors: any = {};
            if (!values.agree1) {
                errors.agree1 = strings.emptyFieldErrorMessage;
                additionalErrorFields.push("agree1");
            }
            if (!values.agreeInform) {
                errors.agreeInform = strings.emptyFieldErrorMessage;
                additionalErrorFields.push("agreeInform");
            }

            validateFields(values.quotation).then((res) => {
                if (res && Object.keys(errors).length === 0) {
                    onFormSubmit(values.quotation);
                } else {
                    setProcessingOpen(false);
                }
            });
            return errors;
        },
        onSubmit: (data) => {},
    });

    useEffect(() => {
        startLoadingFromServer();
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        let event = "travel_conditions_extra";
        console.log("Google Analytics Event = " + event);
        // @ts-ignore
        window.dataLayer.push({ event: event });
    }, []);

    React.useEffect(() => {
        let timout: NodeJS.Timeout;
        getSnippetByName(ChatWidget.TEMPLATE_HINT_FILL_INFO_TRAVEL).then(
            (res) => {
                timout = setTimeout(() => {
                    WidgetTooltip?.open(res.text, WIDGET_DURATION);
                }, 500);
            }
        );

        return () => {
            clearTimeout(timout);
            WidgetTooltip?.close();
        };
    }, []);

    function formatResponse(response: any) {
        return {
            quotationValue: response,
            value: response,
        };
    }

    function formatResponseForAutocomplete(response: any) {
        return {
            quotationValue: {
                code: response.value.value,
                name: response.value.label,
            },
            value: response.value.value,
        };
    }
    function formatSelectedOptionForAutocomplete(option: any) {
        return {
            label: option.name,
            value: {
                value: option.code,
                label: option.name,
            },
        };
    }

    const onChangePayerIsPerson = (
        payerIsPerson,
        setter,
        primaryInsured,
        persons
    ) => {
        if (payerIsPerson) {
            
            setter(
                `quotation.travelWebContract.persons[0].surname`,
                primaryInsured.surname
            );
            setter(
                `quotation.travelWebContract.persons[0].givenName`,
                primaryInsured.givenName
            );
            setter(
                `quotation.travelWebContract.persons[0].birthDate`,
                primaryInsured.birthDate
            );
            setter(
                `quotation.travelWebContract.persons[0].address`,
                primaryInsured.livingAddress.unstructured
            );
            setter(
                `quotation.travelWebContract.persons[0].mobileNumber`,
                primaryInsured.mobileNumber
            );
            setter(
                `quotation.travelWebContract.persons[0].documentNumber`,
                documentNumber
            );
            if (persons.length === 1) {
                setTempSaveValues(persons[0]);
            }
            updateField(
                "persons-travelPerson-registrationDocument-number",
                documentNumber,
                quotation,
                "quotation.travelWebContract."
            );
            clearFirstPersonFields()
        } else {
            setter(
                `quotation.travelWebContract.persons[0].surname`,
                tempSaveValues?.surname ?? null
            );
            setter(
                `quotation.travelWebContract.persons[0].givenName`,
                tempSaveValues?.givenName ?? null
            );
            setter(
                `quotation.travelWebContract.persons[0].birthDate`,
                tempSaveValues?.birthDate ?? null
            );
            setter(
                `quotation.travelWebContract.persons[0].documentNumber`,
                tempSaveValues?.documentNumber ?? null
            );
            setter(
                `quotation.travelWebContract.persons[0].address`,
                tempSaveValues?.address ?? null
            );
            setter(
                `quotation.travelWebContract.persons[0].mobileNumber`,
                tempSaveValues?.mobileNumber ?? null
            );
        }
    };

    const updatePerson = (field: string, value: any, setter: any) => {
        if (formProps.values.quotation.travelWebContract.payerIsPerson) {
            setter(`quotation.travelWebContract.persons[0].${field}`, value);
        }
    };

    function convertContextNameFunction(name: string) {
        return name.replaceAll("-", ".").replaceAll("Party", "");
    }

    useEffect(() => {
        /*
            Вставляємо дані знайденого клієнта в квотейшн та початкові дані форми.
            Якщо не вставляти в інішлВелюес - то воно їх бачити не буде
        */
        if (
            foundPrimaryInsured &&
            !quotation.travelWebContract.primaryInsured.email
        ) {
            setQuotation({
                ...quotation,
                travelWebContract: {
                    ...quotation.travelWebContract,
                    primaryInsured: foundPrimaryInsured,
                    persons: [
                        {
                            ...quotation.travelWebContract.persons[0],
                            birthDate: foundPrimaryInsured.birthDate,
                            givenName: foundPrimaryInsured.givenName,
                            mobileNumber: foundPrimaryInsured.mobileNumber,
                            surname: foundPrimaryInsured.surname,
                        },
                    ],
                },
            });
            setFoundPrimaryInsured(null);
        }
        //eslint-disable-next-line
    }, [foundPrimaryInsured]);

    const saveTempValues = (values) => {
        if( quotation ){
            localStorage.setItem("TRAVEL_quotation", JSON.stringify(values.quotation))
        }
    }

    useEffect(() => {
        return () => {
            setQuotation(formProps.values.quotation)
        }
    }, [formProps.values])

    saveTempValues(formProps.values)

    useEffect(() => {
        if(formProps.values.quotation.travelWebContract.primaryInsured.resident){
            trackHotjar("resident", "travel");
        } else {
            trackHotjar("no-resident", "travel");
        }
    }, [formProps.values.quotation.travelWebContract.primaryInsured.resident])

    const { email } = quotation?.travelWebContract?.primaryInsured || {};
    useTabCloseTracking(email, EventTypeKey.AbandonedTravel);

    const getSelectedPackage = () => {
        switch (quotation.travelWebContract.travelPackage) {
            case "OPTIMAL":
                return strings.optimalAdvertiseTitle;
            case "CLASSIC":
                return strings.classicAdvertiseTitle;
            case "PREMIUM":
                return strings.premiumAdvertiseTitle;
            default:
                return "";
        }
    }

    return (
        <FormikProvider value={formProps}>
            <div className={`${!isMobile ? "displayFlex" : ""}`}>
                <AutoSubmitting updatedFieldsArray={currentlyUpdatedFields}>
                    <form
                        className={`user-details-step ${
                            !isMobile ? "mr-32" : ""
                        }`}
                    >
                        {isMobile ? (
                            <FormRow
                                className={
                                    "user-details-step_resident-options user-details-step_row"
                                }
                            >
                                <Cart
                                    isMobile={isMobile}
                                    selectedPackage={getSelectedPackage()}
                                    personsCount={
                                        formProps.values.quotation
                                            .travelWebContract.touristCount
                                    }
                                    cost={
                                        formProps.values.quotation
                                            .travelWebContract.premium
                                    }
                                    total={
                                        formProps.values.quotation.totalPremium
                                    }
                                />
                            </FormRow>
                        ) : (
                            <></>
                        )}

                        <h3 className={"mb-50"}>{strings.yourDetails}</h3>

                        <FormRow
                            className={
                                "user-details-step_resident-options user-details-step_row"
                            }
                        >
                            <FormItem colspan={isMobile ? 1 : 3}>
                                {/*TODO: 10/14/2021 Переделать поле резидент на параметризируемое:*/}
                                {/*       - реализовать имплементацию SelectOneRadio в ParametrizedFieldOld*/}
                                {/*       - изпользовать ParametrizedFieldOld*/}
                                {/*       - запараметризировать функционал residentCountryHidden и residentCountryUpdate*/}
                                {/*       - удалить residentCountryHidden и residentCountryUpdate*/}
                                {/*       - удалить alwaysHidden, extFieldToUpdate, setExtFieldToUpdate из ParametrizedFieldOld*/}
                                <SelectOneRadioOld
                                    options={[true, false]}
                                    idPrefix={"resident"}
                                    getLabel={(val) => {
                                        const lb = resident.filter(
                                            (item) => item.value === val
                                        );
                                        return lb[0].label;
                                    }}
                                    value={
                                        quotation.travelWebContract
                                            .primaryInsured.resident
                                    }
                                    onChangeListener={(val) => {
                                        let resident = val === "true";
                                        quotation.travelWebContract.primaryInsured.resident =
                                            resident;
                                        formProps.setFieldValue(
                                            "quotation.travelWebContract.primaryInsured.resident",
                                            resident
                                        );

                                        let residentCountry = resident
                                            ? {
                                                  value: {
                                                      value: "UA",
                                                      label: "Україна",
                                                  },
                                              }
                                            : null;
                                        setResidentCountryHidden(resident);
                                        setResidentCountryUpdate({
                                            name: "quotation.travelWebContract.primaryInsured.residentCountry",
                                            value: residentCountry,
                                            contextPath: "mainContract",
                                        });
                                    }}
                                />
                            </FormItem>
                        </FormRow>

                        <FormRow
                            className={
                                "user-details-step_row" +
                                (residentCountryHidden
                                    ? "user-details-step_row__invisible"
                                    : "")
                            }
                            columns={2}
                        >
                            <ParametrizedFieldOld
                                contextName={
                                    "primaryInsuredParty-residentCountry"
                                }
                                quotationName={"quotation.travelWebContract."}
                                context={TravelQuotationCardContext}
                                convertContextNameFunction={
                                    convertContextNameFunction
                                }
                                formatResponse={formatResponseForAutocomplete}
                                formatSelected={
                                    formatSelectedOptionForAutocomplete
                                }
                                alwaysHidden={residentCountryHidden}
                                extFieldToUpdate={residentCountryUpdate}
                                setExtFieldToUpdate={setResidentCountryUpdate}
                                onChangeListener={(val) => {
                                    const countryLabel = val?.label ?? val?.value?.label ?? "";
                                    updatePerson(
                                        "residentCountry",
                                        countryLabel,
                                        formProps.setFieldValue
                                    );
                                }}
                            />
                        </FormRow>

                        <FormRow
                            className={"user-details-step_row mb26"}
                            columns={2}
                        >
                            <ParametrizedFieldOld
                                contextName={"primaryInsuredParty-surname"}
                                quotationName={"quotation.travelWebContract."}
                                context={TravelQuotationCardContext}
                                convertContextNameFunction={
                                    convertContextNameFunction
                                }
                                defaultLabel={strings.travelSurnameLabel}
                                onChangeListener={(val) => {
                                    updatePerson(
                                        "surname",
                                        val,
                                        formProps.setFieldValue
                                    );
                                }}
                                formatResponse={formatResponse}
                                listenerDependency={formProps.values.quotation.travelWebContract.payerIsPerson}
                            />
                            <ParametrizedFieldOld
                                contextName={"primaryInsuredParty-givenName"}
                                quotationName={"quotation.travelWebContract."}
                                defaultLabel={strings.travelNameLabel}
                                context={TravelQuotationCardContext}
                                onChangeListener={(val) => {
                                    updatePerson(
                                        "givenName",
                                        val,
                                        formProps.setFieldValue
                                    );
                                }}
                                convertContextNameFunction={
                                    convertContextNameFunction
                                }
                                listenerDependency={formProps.values.quotation.travelWebContract.payerIsPerson}
                                formatResponse={formatResponse}
                            />
                        </FormRow>

                        <FormRow
                            className={"user-details-step_row"}
                            columns={2}
                        >
                            <ParametrizedFieldOld
                                contextName={"primaryInsuredParty-birthDate"}
                                quotationName={"quotation.travelWebContract."}
                                context={TravelQuotationCardContext}
                                convertContextNameFunction={
                                    convertContextNameFunction
                                }
                                listenerDependency={formProps.values.quotation.travelWebContract.payerIsPerson}
                                onChangeListener={(val) => {
                                    if (val == null) {
                                        updatePerson(
                                            "birthDate",
                                            val,
                                            formProps.setFieldValue
                                        );
                                    } else {
                                        const date = moment(
                                            val,
                                            "DD.MM.YYYY"
                                        ).toDate();
                                        updatePerson(
                                            "birthDate",
                                            moment(date).format("YYYY-MM-DD"),
                                            formProps.setFieldValue
                                        );
                                    }
                                }}
                                formatResponse={(option: string) => {
                                    const date = moment(
                                        option,
                                        "DD.MM.YYYY"
                                    ).toDate();
                                    return {
                                        quotationValue:
                                            moment(date).format("YYYY-MM-DD"),
                                        value: moment(date).format(
                                            "DD.MM.YYYY"
                                        ),
                                    };
                                }}
                            />
                            {formProps.values.quotation.travelWebContract.payerIsPerson ? (
                                <ParametrizedFieldOld
                                    contextName={`primaryInsuredParty-registrationDocument-number`}
                                    defaultLabel={strings.registrationDocument}
                                    quotationName={
                                        "quotation.travelWebContract."
                                    }
                                    context={TravelQuotationCardContext}
                                    convertContextNameFunction={
                                        convertContextNameFunction
                                    }
                                    listenerDependency={formProps.values.quotation.travelWebContract.payerIsPerson}
                                    onChangeListener={(val) => {
                                        updatePerson(
                                            "documentNumber",
                                            val,
                                            formProps.setFieldValue
                                        );
                                    }}
                                    formatResponse={formatResponse}
                                />
                            ) : (
                                <></>
                            )}
                        </FormRow>

                        <FormRow
                            className={"user-details-step_row"}
                            columns={1}
                        >
                            <ParametrizedFieldOld
                                contextName={
                                    "primaryInsuredParty-livingAddress-unstructured"
                                }
                                quotationName={"quotation.travelWebContract."}
                                defaultLabel={strings.travelAddressLabel}
                                onChangeListener={(val) => {
                                    updatePerson(
                                        "address",
                                        val,
                                        formProps.setFieldValue
                                    );
                                }}
                                listenerDependency={formProps.values.quotation.travelWebContract.payerIsPerson}
                                context={TravelQuotationCardContext}
                                convertContextNameFunction={
                                    convertContextNameFunction
                                }
                                formatResponse={formatResponse}
                            />
                        </FormRow>

                        <FormRow
                            className={"user-details-step_row"}
                            columns={2}
                        >
                            <ParametrizedFieldOld
                                contextName={"primaryInsuredParty-mobileNumber"}
                                defaultLabel={strings.mobileNumber}
                                quotationName={"quotation.travelWebContract."}
                                listenerDependency={formProps.values.quotation.travelWebContract.payerIsPerson}
                                mask={"+38(999)9999999"}
                                onChangeListener={(val) => {
                                    updatePerson(
                                        "mobileNumber",
                                        val,
                                        formProps.setFieldValue
                                    );
                                }}
                                context={TravelQuotationCardContext}
                                convertContextNameFunction={(name) => {
                                    return `primaryInsured.mobileNumber`;
                                }}
                                formatResponse={formatResponse}
                            />
                            <ParametrizedFieldOld
                                contextName={"primaryInsuredParty-email"}
                                quotationName={"quotation.travelWebContract."}
                                context={TravelQuotationCardContext}
                                convertContextNameFunction={
                                    convertContextNameFunction
                                }
                                formatResponse={formatResponse}
                            />
                        </FormRow>

                        <FormRow
                            className={"user-details-step_row"}
                            columns={2}
                        >
                            <div className={"checkbox-0"}>
                                <ParametrizedFieldOld
                                    contextName={"payerIsPerson"}
                                    quotationName={"quotation.travelWebContract."}
                                    context={TravelQuotationCardContext}
                                    payerIsPersonValue={formProps.values.quotation.travelWebContract.payerIsPerson}
                                    onChangeListener={(val) => {
                                            formProps.setFieldValue('payerIsPerson', val);
                                            formProps.setFieldValue('quotation.travelWebContract.payerIsPerson', val);
                                            setDocumentNumber(
                                                formProps.values.quotation
                                                    .travelWebContract.persons[0]
                                                    .documentNumber
                                            );
                                            onChangePayerIsPerson(
                                                val,
                                                formProps.setFieldValue,
                                                formProps.values.quotation
                                                    .travelWebContract
                                                    .primaryInsured,
                                                formProps.values.quotation
                                                    .travelWebContract.persons
                                            );
                                            setIsPayerIsPersonCheckbox(val);
                                    }}
                                />
                            </div>
                        </FormRow>
                        {formProps.values.quotation.travelWebContract.persons.map(
                            (person, index) => {
                                if (formProps.values.quotation.travelWebContract.payerIsPerson) {
                                    if (index > 0) {
                                        return (
                                            <div key={person.id}>
                                                <AdditionalPerson
                                                    personNumber={index}
                                                    formatResponse={
                                                        formatResponse
                                                    }
                                                />
                                            </div>
                                        );
                                    }
                                } else {
                                    return (
                                        <div key={person.id}>
                                            <AdditionalPerson
                                                personNumber={index}
                                                formatResponse={formatResponse}
                                            />
                                        </div>
                                    );
                                }
                            }
                        )}

                        <FormRow
                            className={"user-details-step_row"}
                            columns={1}
                        >
                            <div className={"checkbox-0"}>
                                <CheckboxOld
                                    label={getAgreeAboutProductLabel(ProductType.TRAVEL)}
                                    onChangeListener={(val) => {
                                        setAgreeInformCheckbox(val);
                                    }}
                                    fieldValue={formProps.values.agreeInform}
                                    name={"agreeInform"}
                                    disabled={false}
                                    hidden={false}
                                />
                            </div>
                        </FormRow>

                        <FormRow
                            className={"user-details-step_row"}
                            columns={1}
                        >
                            <div className={"checkbox-0"}>
                                <CheckboxOld
                                    additionalInfo={
                                        <p
                                            className={
                                                "checkbox-additional-info-text"
                                            }
                                        >
                                            {strings.travelAgree1_1}
                                        </p>
                                    }
                                    label={strings.travelAgree1_2}
                                    onChangeListener={(val) => {
                                        setAgree1Checkbox(val);
                                    }}
                                    fieldValue={formProps.values.agree1}
                                    name={"agree1"}
                                    disabled={false}
                                    hidden={false}
                                />
                            </div>
                        </FormRow>

                        <StepControls
                            onNext={async (event) => {
                                event.preventDefault();
                                setProcessingOpen(true);
                                const date = new Date();
                                log.sendLog(
                                    date,
                                    LogFunctionalModule.STORE_TRAVEL,
                                    "INFO",
                                    "UER_DETAILS_FORM_NEXT_HANDLER",
                                    [
                                        {
                                            quotation: quotation,
                                            formProps: formProps,
                                        },
                                    ],
                                    ""
                                );
                                if (!payerIsPersonCheckbox) {
                                    if (
                                        !formProps.values.quotation
                                            .travelWebContract.persons[0]
                                            .documentNumber
                                    ) {
                                        await updateField(
                                            "persons-travelPerson-registrationDocument-number",
                                            null,
                                            formProps.values,
                                            "mainContract.get().riskObjects.get(0)"
                                        );
                                        setProcessingOpen(false);
                                        //return
                                    }
                                }
                                formProps.setSubmitting(true);
                            }}
                            onBack={() => {
                                const date = new Date();
                                log.sendLog(
                                    date,
                                    LogFunctionalModule.STORE_TRAVEL,
                                    "INFO",
                                    "USER_DETAILS_FORM_BACK_HANDLER",
                                    [
                                        {
                                            quotation: quotation,
                                            formProps: formProps,
                                        },
                                    ],
                                    ""
                                );
                                backStepHandler(quotation);
                            }}
                            leftSteps={1}
                            nextIsAvailable={nextIsAvailable}
                        />
                    </form>
                </AutoSubmitting>
            </div>
        </FormikProvider>
    );
};
